import React, { FC, useState } from "react";
import { formatEffectiveDate, humanFormatEffectiveDate } from "utils/retail/plans";
import RatesDropdown from "containers/retail/sections/energy-rates-3/RatesDropdown";
import RatesMonthCalendar from "containers/retail/sections/energy-rates-3/RatesMonthCalendar";

interface RatesContractStartDateProps {
  effectiveDate: string;
  minEffectiveDate: Date;
  onChangeEffectiveDate: (effectiveDate: string) => void;
}

const RatesContractStartDate: FC<RatesContractStartDateProps> = (props) => {
  const { effectiveDate, minEffectiveDate, onChangeEffectiveDate } = props;
  const [open, setOpen] = useState<boolean>(false);
  const onToggle = () => setOpen(!open);

  const onChangeDate = (date) => {
    onToggle();
    onChangeEffectiveDate(formatEffectiveDate(date));
  };

  return (
    <RatesDropdown
      placeholder={humanFormatEffectiveDate(new Date(effectiveDate))}
      open={open}
      onToggle={onToggle}
      width={160}
    >
      <RatesMonthCalendar
        onChange={onChangeDate}
        value={effectiveDate}
        minDate={minEffectiveDate}
      />
    </RatesDropdown>
  );
};

export default RatesContractStartDate;
